/* eslint-disable no-lone-blocks */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable prettier/prettier */
import React from 'react';
import { View } from 'react-native';

import { navigateTo } from '@helpers';
import Button from '@styles/buttons';

const Content = () => {
  return (
    <View style={{ width: '100%', marginTop: 300, alignItems: 'center' }}>
      <View style={{ width: 250 }}>
        <Button {...{ onPress: () => navigateTo('List') }}>Open list example</Button>
      </View>
    </View>
  );
};

export default Content;
